<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-row>
        <v-col cols="2">
          <v-icon @click="goBack">
            mdi-chevron-left
          </v-icon>
        </v-col>
        <v-col class="d-flex justify-space-around">
          <v-toolbar-title class="pageTitle">
            Offene Pfandrückgaben
          </v-toolbar-title>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
        </v-col>
      </v-row>
    </v-toolbar>
    <v-divider class="headerDivider"/>

     <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">
        <v-card class="depositListCard">
          <v-container class="depositListContainer">
            <table>
              <thead>
              <td>
                <b>Pfandtyp</b>
              </td>

              <td>
                <b>Anzahl</b>
              </td>
              </thead>
              <tbody>
              <tr v-for="depositItem in depositValues"
                  :key="depositItem.itemNo">
                <td>
                          <span>
                            {{ depositItem.description }}
                            <br>
                            {{ depositItem.itemNo }}
                          </span>
                </td>
                <td>
                  <v-text-field class="searchCbx depositListInput"
                                rounded
                                dense
                                outlined
                                type="number"
                                disabled
                                :v-model="depositItem.itemNo"
                                :value="savedDeposit === null ? '' : savedDeposit[depositItem.itemNo]"
                  >

                  </v-text-field>
                </td>
              </tr>
              </tbody>
            </table>
            <table>
              <tbody>
              <th>
                <tr>
                  <td>
                    DPG Pfandsäcke
                  </td>
                </tr>
              </th>
              <tr v-for="(depositItem,index) in sachetValues"
                  :key="depositItem.itemNo+'-'+index">
                <!--
                <td>
                    <span>
                      {{ depositItem.description }}
                      <br>
                      {{ depositItem.itemNo }}
                    </span>
                </td>
                -->
                <td>
                  <v-text-field class="searchCbx depositListInput"
                                rounded
                                dense
                                outlined
                                disabled
                                type="input"
                                :v-model="depositItem.itemNo[index]"
                                :value="savedDeposit === null ? '' : (savedDeposit[depositItem.itemNo] !== undefined ? savedDeposit[depositItem.itemNo][index] : '')"
                  >

                  </v-text-field>
                </td>
              </tr>
              </tbody>
            </table>
          </v-container>

        <v-container class="signatureContainer">
          <div class="signatureWrapper"
                    v-if="this.signature !== null"
          >
            <div class="signatureDisplay">
              <v-btn class="deleteSignature-btn">
                <close-btn/>
              </v-btn>
              <div class="signatureSVG" v-html="signature">

              </div>
            </div>
          </div>
          <div v-if="this.signature !== null"
              class="signatureSubline">
            Unterschrift
          </div>
        </v-container>
        <v-btn
            class="continueBtn"
            color="primary"
            v-if="onlineState"
            @click="endDepositCollection"
        >
          Pfandrückgabe abschließen
        </v-btn>
        <v-btn
            class="continueBtn"
            color="primary"
            v-if="!onlineState"
        >
          Du bist offline.
        </v-btn>
      </v-card>
       <v-snackbar :value="triggerSnackbar" class="depositSnackBar">
         <span>Die Pfandrückgabe konnte nicht verarbeitet werden. Bitte versuche es später erneut.</span>
       </v-snackbar>
       <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import closeBtn from "@/assets/closeBtn";
import {mapMutations, mapActions} from 'vuex'

export default {
  name: "savedDepositDetails",
  components: {closeBtn},
  data() {
    return {
      totalDeposit: null,
      savedDeposit: null,
      depositValues: null,
      signature: null,
      signaturePNG: null,
      onlineState: true,
      triggerSnackbar: false
    }
  },

  computed: {
    sachetValues() {
      let sachet = this.depositValues.filter(el => {
        if(el.itemNo === '79110') {
          return true
        } else {
          return false
        }
      })
      let arr = []
      if(this.savedDeposit !== null && this.savedDeposit['79110'] !== undefined) {
        let sachets = this.savedDeposit['79110'].length
        for(let i = 0; i<sachets;i++) {
          if(this.savedDeposit['79110'][i] !== undefined) {
            arr.push(sachet[0])
          }
        }
      } else {
        arr.push(sachet[0])
      }
      return arr
    }
  },
  methods: {
    goBack() {
      router.go(-1)
    },

    ...mapActions({
      sendDepositCollectionFromSavedState: 'sendDepositCollectionFromSavedState'
    }),

    ...mapMutations({
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    async endDepositCollection() {
      await this.sendDepositCollectionFromSavedState(this.totalDeposit).then((response) => {
        if(response === false) {
          this.triggerSnackbar = true
          console.log('Request Failed. Nothing to do')
        }
        else {
          let id = router.currentRoute.params.id
          let saved = JSON.parse(localStorage.getItem('savedDeposits'))
          saved.splice(id, 1);
          localStorage.setItem('savedDeposits', JSON.stringify(saved))
          router.push({name: 'depositActions'})
        }
      }).catch(() => {

      })
    },
  },

  created() {
    this.setHeaderVisibility(false)

    window.addEventListener("offline", () => {
      this.onlineState = false
    })
    window.addEventListener("online", () => {
      this.onlineState = true
    })

    //pre-Check if offline or online
    this.onlineState = window.navigator.onLine

    let id = router.currentRoute.params.id
    id = id.toString()
    if(localStorage.getItem('savedDeposits') !== null) {
      let saved = JSON.parse(localStorage.getItem('savedDeposits'))
      if(Object.keys(saved).indexOf(id) > -1) {

        this.totalDeposit = saved[id]
        this.savedDeposit = saved[id].deposit
        this.market = saved[id].market

        if(Object.keys(saved[id]).indexOf('signature') > -1) {
          this.signature = saved[id].signature
          this.signaturePNG = saved[id].signature_jpeg
        }
      }
    else {
        router.push({name: 'depositActions'})
      }
    }
    else {
      router.push({name: 'depositActions'})
    }


    this.depositValues = JSON.parse(localStorage.getItem('depositValues'))
  }
}
</script>

<style scoped>

</style>
